import { assign, includes } from 'lodash'

import { SEGMENT_TRACKING_BLACKLIST } from 'constants/trackingConstants'
import * as OrgSelectors from 'modules/org/selectors'
import * as UserSelectors from 'modules/user/selectors'

import { store } from '../index'

export const track = (eventName, properties) => {
  const state = store.getState()
  const email = UserSelectors.getEmail(state)
  const orgId = OrgSelectors.getOrgId(state)

  if (!window.analytics || includes(SEGMENT_TRACKING_BLACKLIST, orgId)) {
    return
  }
  const propertiesWithEmail = assign({}, { email, orgId }, properties)
  window.analytics.track(eventName, propertiesWithEmail)
}

export const identifyUser = (traits = {}, orgId = undefined, userId = undefined) => {
  const state = store.getState()
  const email = UserSelectors.getEmail(state)
  const finalUserId = userId || UserSelectors.getUserId(state)
  const finalOrgId = orgId || OrgSelectors.getOrgId(state)
  const name = UserSelectors.getName(state)
  const userJwt = UserSelectors.getUserJwt(state)

  if (!finalUserId) {
    return
  }

  if (userJwt && window.drift && window.drift.setUserJwt) {
    window.drift.setUserJwt(userJwt)
  }

  return (
    window.analytics &&
    window.analytics.identify(
      `${finalOrgId}-${finalUserId}`,
      {
        name,
        email,
        orgId: finalOrgId,
      ...traits,
      },
      { integrations: { drift: { userJwt }}}
    )
  )
}

export const page = (pageName, properties = {}) => {

  const state = store.getState()
  const orgId = OrgSelectors.getOrgId(state)

  if (!window.analytics || includes(SEGMENT_TRACKING_BLACKLIST, orgId)) {
    return
  }
  window.analytics.page(pageName, properties)
}



// WEBPACK FOOTER //
// ./src/utils/trackingUtils.js